import { mapSelectors } from '@citypantry/util';
import { getPublicState } from '../app.state';
import { getMealPlan, getProposedOrderId } from '../public/public.state';

export const MealPlanSelectors = mapSelectors(getPublicState, {
  getMealPlan,
  getProposedOrderId,
});
